import { Component, OnInit, Input } from '@angular/core';
import { AdvocacyStageService } from '../../../value-tracker/_services/advocacy-stage.service';
import { drawDOM, exportPDF, Group, pdf } from '@progress/kendo-drawing';
import { saveAs } from '@progress/kendo-file-saver';
import { ManageCaseService } from '../../../value-tracker/_services/manage-case.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html'
})
export class GenerateReportComponent implements OnInit {

  isLoading: boolean;
  isPageBreakAdded = false;
  report: any;
  exportFileData: any;
  headerText: string;
  translatedText = [];
  downloadAgreemntButton = [];
  downloadReportButton = [];
  pdfCloseButton = [];
  @Input() reportType: string;
  @Input() reportParameters: any;
  printPaperSize = 2158;

  constructor(private advocacyStageService: AdvocacyStageService,
    private manageCaseService: ManageCaseService,
    public activeModal: NgbActiveModal,
    private translate: TranslateService) {
    translate.get([
      'SOLUTION_SUMMARY.PDF_DISCOVERY_HEADERTEXT',
      'SOLUTION_SUMMARY.PDF_SOLUTION_SUMMARY_HEADERTEXT',
      'SOLUTION_SUMMARY.DOWNLOAD_AGREEMENT',
      'SOLUTION_SUMMARY.PDF_CLOSE',
      'SOLUTION_SUMMARY.DOWNLOAD_REPORT',
    ]).subscribe((translations: string) => {
      this.translatedText[0] = translations['SOLUTION_SUMMARY.PDF_DISCOVERY_HEADERTEXT'];
      this.translatedText[1] = translations['SOLUTION_SUMMARY.PDF_SOLUTION_SUMMARY_HEADERTEXT'];
      this.translatedText[2] = translations['SOLUTION_SUMMARY.DOWNLOAD_AGREEMENT'];
      this.translatedText[3] = translations['SOLUTION_SUMMARY.PDF_CLOSE'];
      this.translatedText[4] = translations['SOLUTION_SUMMARY.DOWNLOAD_REPORT'];
    });

  }

  ngOnInit() {
    this.pdfCloseButton = this.translatedText[3];
    if (this.reportType === 'SolutionSummary') {
      this.downloadAgreemntButton = this.translatedText[4];
      this.getSolutionSummaryReport();
      this.headerText = this.translatedText[1];
    } else if (this.reportType === 'TotalOpportunity') {
      this.headerText = this.translatedText[0];
      this.downloadAgreemntButton = this.translatedText[2];
      this.getTotalOpprtunityReport();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  getSolutionSummaryReport() {
    this.isLoading = true;
    let reportData: any;
    const solutionSelectionData = this.advocacyStageService.getSolutionData();
    this.advocacyStageService.getSolutionSummary(solutionSelectionData.solutionSummaryData, solutionSelectionData.isLeased).subscribe(
      response => {
        reportData = response._body;
        this.report = reportData;
        this.isLoading = false;
      }, error => {
        // this.showToaster('error', this.translatedText[4]);
        this.isLoading = false;
      }
    );
  }

  downloadReport() {
    this.addPageBreak();
    let exportFileName: string;
    const options = <pdf.PDFOptions>{
      paperSize: 'auto',
      multiPage: true,
      margin: '18pt',
      imageResolution: 96
    };
    const reportElement = document.getElementById('exportToPDFElement');
    if (this.reportType === 'TotalOpportunity') {
      exportFileName = 'Discovery Agreement.pdf';
    } else if (this.reportType === 'SolutionSummary') {
      exportFileName = 'Solution Summary.pdf';
    }
    drawDOM(reportElement, {
      forcePageBreak: '.new-page', // add this class to each element where you want manual page break
      // keepTogether: 'section',
      template: (data) => `<div class="d-flex px-3">` +
        document.getElementById('exportToPDFElementFooter').innerHTML.toString() +
        `<p class="pr-2">--<p><p class="pr-3">Page ${data.pageNum} of ${data.totalPages}</p></div>`
    }).then((group: Group) => {
      return exportPDF(group, options);
    }).then((dataUri) => {
      this.exportFileData = dataUri;
      saveAs(dataUri, exportFileName);
      this.isPageBreakAdded = true;

    });
  }

  public addPageBreak() {
    let isnewPageAdded = false;
    const sections = document.querySelectorAll('#exportToPDFElement section');
    let totalHeight = 0;
    for (let i = 0; i < sections.length; i++) {
      totalHeight = totalHeight + sections[i].clientHeight;
      if (!this.isPageBreakAdded) {
        if (totalHeight > this.printPaperSize) {
          const lastSection = sections[i - 1];
          const height = lastSection.clientHeight + (this.printPaperSize - (totalHeight - sections[i].clientHeight));
          if (!isnewPageAdded) {
            lastSection.setAttribute('style', 'height:' + height + 'px');
          }
          sections[i].classList.add('new-page');
          isnewPageAdded = true;
          sections[i].innerHTML = '<div class="headerBar"></div>' + sections[i].innerHTML;
          totalHeight = sections[i].clientHeight;
        }
        if (totalHeight < this.printPaperSize && i === (sections.length - 1)) {
          const pageLastSection = sections[i];
          const pageLastSectionHeight = pageLastSection.clientHeight + (this.printPaperSize - totalHeight);
          pageLastSection.setAttribute('style', 'height:' + pageLastSectionHeight + 'px');
        }
      }
    }
  }



  // public addPageBreak() {
  //   const sections = document.querySelectorAll('#exportToPDFElement section');
  //   let totalHeight = 0;
  //   for (let i = 0; i < sections.length; i++) {
  //     totalHeight = totalHeight + sections[i].clientHeight;
  //     //  if (sections[i - 1] && sections[i - 1].className !== undefined && !sections[i - 1].className.includes('new-page')) {
  //     if (!this.isPageBreakAdded) {
  //       if (totalHeight > this.printPaperSize) {
  //         sections[i].className += 'new-page';
  //         sections[i].innerHTML = '<div class="headerBar"></div>' + sections[i].innerHTML;
  //         totalHeight = sections[i].clientHeight;
  //         totalHeight = 0;
  //       }
  //     }
  //   }
  //   // document.querySelectorAll('.opp-value-basis')[0].className += ' new-page headerBar';
  // }

  getTotalOpprtunityReport() {
    this.isLoading = true;
    let reportOpportunityData: any;
    this.manageCaseService.downloadAgreement(this.reportParameters).subscribe(response => {
      reportOpportunityData = response._body;
      this.report = reportOpportunityData;
      this.isLoading = false;
    }, error => {
      // this.showToaster('error', this.translatedText[4]);
      this.isLoading = false;
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/generate-report/generate-report.component.ts